module.exports = __webpack_public_path__ + "images/emoji/wrench.06554b5c232dbdc8722e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/wrench.png
// module id = Yp9w
// module chunks = 13